import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import Welcome from './Welcome'
import { FaLanguage } from 'react-icons/fa'

const AllSubjectList = () => {
  const navigate = useNavigate()

  const toNavigate = (path: any) => {
    navigate(path)
  }

  const class1Subject = {
    title: 'कक्षा 1',
    description: 'कक्षा 1 के सभी विषयों के लिए पाठ्यपुस्तकें',
    to: '/learning/class1', // Updated to common route
    icon: <FaLanguage className='fs-1 mb-3' />,
    bgColor: 'linear-gradient(135deg, #f2a7a7, #e74545)',
    textColor: 'white'
  }

  const handleToNavigate = (path: any) => {
    toNavigate(path)
  }

  return (
    <div
      className='vh-100 w-100 position-relative'
      style={{
        backgroundImage: `url(https://botgo.s3.ap-south-1.amazonaws.com/91147661736330549922-ShikshaSaathi.jpeg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div
        className='position-absolute top-0 start-0 w-100 h-100'
        style={{
          background: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1
        }}
      ></div>

      <div className='row gy-5 gx-5 justify-content-center position-relative' style={{ zIndex: 2 }}>
        <Welcome />

        <div className='col-12 text-center'>
          <h2
            className='display-4 text-white mb-5'
            style={{
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
            }}
          >
            सीखने के लिए विषय चुनें
          </h2>
          <div className='d-flex justify-content-center'>
            <motion.button
              className='btn btn-lg d-flex flex-column align-items-center rounded-4 p-5'
              onClick={() => handleToNavigate(class1Subject.to)}
              whileHover={{ scale: 1.1, rotate: 10 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.3 }}
              style={{
                background: class1Subject.bgColor,
                color: class1Subject.textColor,
                border: 'none',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                fontSize: '1.8rem',
                transition: 'all 0.3s ease-in-out',
                padding: '20px 40px'
              }}
            >
              {class1Subject.icon}
              <span
                className=''
                style={{
                  fontWeight: 'bold',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  fontSize: '5rem'
                }}
              >
                {class1Subject.title}
              </span>
              <p className='h6 mt-3' style={{ fontSize: '2rem' }}>
                {class1Subject.description}
              </p>
            </motion.button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AllSubjectList
